// Copyright (c) Bentley Systems
import { useState } from "react";
import { useDownloadFile as UseDownloadFile } from "./useDownloadFile";
import {
  ArchiveActionButton,
  ButtonState,
  ButtonType,
} from "../ArchiveActionButton";
import sanitize from 'sanitize-filename';

export type DownloadSampleCsvFileProps = {
  readonly apiDefinition: () => Promise<Blob | undefined>;
  onError: (responseStatusCode: number, activityId: string | undefined) => void;
  getFileName: () => string;
}

export const DownloadFileActionButton = (props: DownloadSampleCsvFileProps) => {
  const [buttonState, setButtonState] = useState<ButtonState>(
    ButtonState.Primary
  );

  const preDownloading = () => setButtonState(ButtonState.Loading);
  const postDownloading = () => setButtonState(ButtonState.Primary);

  const onErrorDownloadFile = (
    responseStatusCode: number,
    activityId: string | undefined
  ) => {
    setButtonState(ButtonState.Primary);
    props.onError(responseStatusCode, activityId);
  };

  const getSanitizedFileName = () => {
    return sanitize(props.getFileName());
  };

  const { download } = UseDownloadFile({
    apiDefinition: props.apiDefinition,
    preDownloading,
    postDownloading,
    onError: onErrorDownloadFile,
    getSanitizedFileName,
  });

  return (
    <div>
      <ArchiveActionButton
        buttonState={buttonState}
        onClick={download}
        buttonType={ButtonType.Download}
      />
    </div>
  );
};
